<template>
  <div>
    <div class="columns is-vcentered">
      <div class="column is-one-fifth">
        <h5 class="title is-5">Kurallar</h5>
      </div>
      <div class="column">
        <b-field label="Kalkış İlçe" class="has-check" horizontal>
          <b-field grouped group-multiline>
            <div class="control">
              <b-checkbox
                v-model="transfer.rules.from_district_id"
                native-value="required"
              >
                Zorunlu
              </b-checkbox>
              <b-checkbox
                v-model="transfer.field_visibility.from_district_id"
                native-value="true"
              >
                Göster
              </b-checkbox>
            </div>
          </b-field>
        </b-field>

        <b-field label="Kalkış Mahalle" class="has-check" horizontal>
          <b-field grouped group-multiline>
            <div class="control">
              <b-checkbox
                v-model="transfer.rules.from_neighborhood_id"
                native-value="required"
              >
                Zorunlu
              </b-checkbox>
              <b-checkbox
                v-model="transfer.field_visibility.from_neighborhood_id"
                native-value="true"
              >
                Göster
              </b-checkbox>
            </div>
          </b-field>
        </b-field>

        <b-field label="Varış İlçe" class="has-check" horizontal>
          <b-field grouped group-multiline>
            <div class="control">
              <b-checkbox
                v-model="transfer.rules.to_district_id"
                native-value="required"
              >
                Zorunlu
              </b-checkbox>
              <b-checkbox
                v-model="transfer.field_visibility.to_district_id"
                native-value="true"
              >
                Göster
              </b-checkbox>
            </div>
          </b-field>
        </b-field>

        <b-field label="Varış Mahalle" class="has-check" horizontal>
          <b-field grouped group-multiline>
            <div class="control">
              <b-checkbox
                v-model="transfer.rules.to_neighborhood_id"
                native-value="required"
              >
                Zorunlu
              </b-checkbox>
              <b-checkbox
                v-model="transfer.field_visibility.to_neighborhood_id"
                native-value="true"
              >
                Göster
              </b-checkbox>
            </div>
          </b-field>
        </b-field>

        <b-field label="Talep Edilen Birim" class="has-check" horizontal>
          <b-field grouped group-multiline>
            <div class="control">
              <b-checkbox
                v-model="transfer.rules.requested_unit_id"
                native-value="required"
              >
                Zorunlu
              </b-checkbox>
              <b-checkbox
                v-model="transfer.field_visibility.requested_unit_id"
                native-value="true"
              >
                Göster
              </b-checkbox>
            </div>
          </b-field>
        </b-field>
      </div>
    </div>

    <hr>

    <div class="columns is-vcentered mt-2">
      <div class="column is-one-fifth">
        <h5 class="title is-5">Varsayılan Değerler</h5>
      </div>
      <div class="column">
        <b-field horizontal label="Kalkış İl & İlçe">
          <b-field grouped group-multiline>
            <b-select
              v-model="transfer.defaults.from_province_id"
              placeholder="İl"
              expanded
              @change.native="transfer.defaults.from_district_id = null"
            >
              <option
                v-for="province in provinces"
                :key="province.id"
                :value="province.id"
              >
                {{ province.name }}
              </option>
            </b-select>
            <b-select
              v-model="transfer.defaults.from_district_id"
              placeholder="İlçe"
              expanded
            >
              <option
                v-for="district in districts(transfer.defaults.from_province_id)"
                :key="district.id"
                :value="district.id"
              >
                {{ district.name }}
              </option>
            </b-select>
          </b-field>
        </b-field>

        <b-field horizontal label="Varış İl & İlçe">
          <b-field grouped group-multiline>
            <b-select
              v-model="transfer.defaults.to_province_id"
              placeholder="İl"
              expanded
              @change.native="transfer.defaults.to_district_id = null"
            >
              <option
                v-for="province in provinces"
                :key="province.id"
                :value="province.id"
              >
                {{ province.name }}
              </option>
            </b-select>
            <b-select
              v-model="transfer.defaults.to_district_id"
              placeholder="İlçe"
              expanded
            >
              <option
                v-for="district in districts(transfer.defaults.to_province_id)"
                :key="district.id"
                :value="district.id"
              >
                {{ district.name }}
              </option>
            </b-select>
          </b-field>
        </b-field>

        <b-field horizontal label="Kalkış Açık Adres">
          <b-input
            v-model.trim="transfer.defaults.from_address_line"
            type="textarea"
            rows="3"
            placeholder="Kalkış Açık Adres"
          />
        </b-field>

        <b-field horizontal label="Varış Açık Adres">
          <b-input
            v-model.trim="transfer.defaults.to_address_line"
            type="textarea"
            rows="3"
            placeholder="Varış Açık Adres"
          />
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      transfer: {
        rules: {
          from_district_id: [],
          from_neighborhood_id: [],
          to_district_id: [],
          to_neighborhood_id: [],
          requested_unit_id: [],
        },
        field_visibility: {
          from_district_id: true,
          from_neighborhood_id: true,
          to_district_id: true,
          to_neighborhood_id: true,
          requested_unit_id: true,
        },
        defaults: {
          from_province_id: null,
          from_district_id: null,
          from_address_line: null,
          to_province_id: null,
          to_district_id: null,
          to_address_line: null,
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      settings: 'settings/settings',
      provinces: 'provinces/provinces',
      districts: 'provinces/districts',
    }),
  },
  async created () {
    if (this.settings('transfer').length === 0) {
      this.$emit('loading', true)

      await this.fetchSettings()

      this.$emit('loading', false)
    }

    this.settings('transfer').forEach(({ name, payload }) => {
      if (payload.length !== 0) {
        this.transfer[name] = payload
      }
    })

    this.normalizeRules();

    if (this.provinces.length === 0) {
      this.fetchProvinces()
    }
  },
  methods: {
    ...mapActions({
      fetchSettings: 'settings/index',
      update: 'settings/update',
      fetchProvinces: 'provinces/index',
    }),
    normalizeRules () {
      const keys = [
        'from_district_id',
        'from_neighborhood_id',
        'to_district_id',
        'to_neighborhood_id',
        'requested_unit_id',
      ]
      keys.forEach(k => {
        const v = this.transfer.rules?.[k]
        if (Array.isArray(v)) return
        this.transfer.rules[k] = v === true ? ['required'] : []
      })
    },
    save () {
      this.normalizeRules();
      return this.update({ transfer: this.transfer })
    },
  },
}
</script>
